import UserService from "rc-app/services/UserService";
import React, { useEffect } from "react";
import LandingNav from "rc-app/components/LandingNav";

export const TermsOfUse = () => {
  // index.html sets body { overflow: hidden } globally for the authenticated app.
  // Marketing/legal pages need the body to scroll — restore it on mount.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "auto";
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <>
      {!UserService.isLoggedIn() && (
        <>
          <LandingNav />
        <div className="max-w-6xl mx-auto  font-sans text-gray-800 pt-[5rem] md:pt-[5rem] lg:pt-[6rem] px-2 lg:px-3">
          <div className="bg-white shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              General Terms & Conditions
            </h2>
            <p className="mb-4 text-justify">
              The website Openskyvr.com and the platform login using the link to
              the meta assets platform:
              <a
                href="https://opensky-agent-app.netlify.app/"
                className="text-blue-600 hover:underline"
              >
                {" "}
                https://opensky-agent-app.netlify.app/
              </a>
              including its desktop and mobile versions, as well as any related
              applications (hereinafter referred to as "Site and App"), is owned
              by Hospinet Infrastructure Private Limited, headquartered at
              Hyderabad India as Emerald 909, My Home Jewel, Madeenaguda,
              Hyderabad 500049, Telangana, India and CIN U45200TG2021PTC158262
              (hereinafter referred to as "Owner").
            </p>
            <p className="mb-4 text-justify">
              By accessing and using the Site and its associate platform, App
              and other digital assets, and utilizing the services provided
              therein, users are deemed to accept these General Conditions of
              Use (hereinafter "Conditions"). It is strongly recommended that
              you carefully read and understand these Conditions before using
              the Site and App for any purpose related to the services offered.
            </p>
          </div>

          <div className="space-y-8">
            {/* User Status */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">User Status</h2>
              <p className="mb-4 text-justify">
                By using any service provided on the Site and App (hereinafter
                "Service" or "Services"), you automatically become a User
                (hereinafter "User" or "Users"). In general, Users are required
                to register to gain access to the Services. Registration will
                follow the procedures outlined for each specific Service.
              </p>
              <p className="mb-4 text-justify">
                This is a Business to Business ("B2B") and a Business to
                Business to Customer ("B2B2C") solution platform. Most of the
                Services offered through the Site, platform and App are free for
                last-mile customers; however, some features or options require a
                paid subscription or purchases from the intermediaries
                positioning to the end customers.
              </p>
            </section>

            {/* Types of Users */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">Types of Users</h2>
              <div className="mb-4">
                <h3 className="text-xl font-medium mb-2">Simple Users:</h3>
                <p className="text-justify">
                  These are private individuals or property buyers who use the
                  Site and App for purposes different from Professional Users.
                  They typically use the platform to evaluate the shortlisted
                  properties and relevant information identified by their agent
                  for them to evaluate. These users will be provided by user
                  credentials to access the shortlisted properties.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-medium mb-2">
                  Professional Users:
                </h3>
                <p className="text-justify">
                  These are real estate agents, construction companies,
                  developers, builders and other professionals in the real
                  estate industry who use the platform to showcase and market
                  their projects and properties to Simple Users. Professional
                  Users gain access to specialized Services only after
                  contacting the Owner to activate their account, which is
                  subject to signing a service contract (hereinafter "Service
                  Contract").
                </p>
              </div>
            </section>

            {/* Permitted and Prohibited Uses */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Permitted and Prohibited Uses
              </h2>
              <p className="mb-4 text-justify">
                Commercial use of the Site and App outside the Service Contract,
                including access, transfer, or misuse of information contained
                within, is strictly prohibited and will be prosecuted according
                to the law.
              </p>
              <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                <p className="font-medium text-red-700">
                  Prohibited activities include:
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1 text-justify">
                  <li>
                    Transmitting or distributing any material that violates the
                    law
                  </li>
                  <li>Using the Site for illegal or unethical activities</li>
                  <li>Reproducing content without authorization</li>
                </ul>
              </div>
            </section>

            {/* Intellectual Property */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Intellectual Property
              </h2>
              <p className="text-justify">
                The Owner is the rightful holder of all intellectual and
                industrial property rights related to the Site and App,
                including, but not limited to, texts, images, graphics,
                software, and trademarks. Users may not reproduce, modify,
                distribute, or otherwise exploit these elements without prior
                authorization from the Owner or other rights holders.
              </p>
            </section>

            {/* Contact Information */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Contact Information
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium mb-2">
                    For communications with authorities:
                  </h3>
                  <a
                    href="mailto:product@hospinetinfra.com"
                    className="text-blue-600 hover:underline"
                  >
                    product@hospinetinfra.com
                  </a>
                </div>
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium mb-2">
                    For communications with Users:
                  </h3>
                  <a
                    href="mailto:devices@hospinetinfra.com"
                    className="text-blue-600 hover:underline"
                  >
                    devices@hospinetinfra.com
                  </a>
                </div>
              </div>
              <p className="mt-4 text-sm text-gray-600 text-justify">
                All communications must be in English.
              </p>
            </section>

            {/* Acceptance Button */}
            {/* <div className="flex justify-center mt-8">
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg shadow-md transition duration-300">
                I Accept the Terms & Conditions
              </button>
            </div> */}
          </div>
        </div>
        </>
      )}

      {UserService.isLoggedIn() && (
        <div className="max-w-6xl mx-auto px-4 py-8 font-sans text-gray-800 ">
          <header className="mb-8">
            <h1 className="text-3xl font-bold text-center mb-2">
              Terms & Conditions
            </h1>
            {/* <p className="text-center text-gray-600">Last updated: {new Date().toLocaleDateString()}</p> */}
          </header>

          <div className="bg-white shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              General Terms & Conditions
            </h2>
            <p className="mb-4 text-justify">
              The website Openskyvr.com and the platform login using the link to
              the meta assets platform:
              <a
                href="https://opensky-agent-app.netlify.app/"
                className="text-blue-600 hover:underline"
              >
                {" "}
                https://opensky-agent-app.netlify.app/
              </a>
              including its desktop and mobile versions, as well as any related
              applications (hereinafter referred to as "Site and App"), is owned
              by Hospinet Infrastructure Private Limited, headquartered at
              Hyderabad India as Emerald 909, My Home Jewel, Madeenaguda,
              Hyderabad 500049, Telangana, India and CIN U45200TG2021PTC158262
              (hereinafter referred to as "Owner").
            </p>
            <p className="mb-4 text-justify">
              By accessing and using the Site and its associate platform, App
              and other digital assets, and utilizing the services provided
              therein, users are deemed to accept these General Conditions of
              Use (hereinafter "Conditions"). It is strongly recommended that
              you carefully read and understand these Conditions before using
              the Site and App for any purpose related to the services offered.
            </p>
          </div>

          <div className="space-y-8">
            {/* User Status */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">User Status</h2>
              <p className="mb-4 text-justify">
                By using any service provided on the Site and App (hereinafter
                "Service" or "Services"), you automatically become a User
                (hereinafter "User" or "Users"). In general, Users are required
                to register to gain access to the Services. Registration will
                follow the procedures outlined for each specific Service.
              </p>
              <p className="mb-4 text-justify">
                This is a Business to Business ("B2B") and a Business to
                Business to Customer ("B2B2C") solution platform. Most of the
                Services offered through the Site, platform and App are free for
                last-mile customers; however, some features or options require a
                paid subscription or purchases from the intermediaries
                positioning to the end customers.
              </p>
            </section>

            {/* Types of Users */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">Types of Users</h2>
              <div className="mb-4">
                <h3 className="text-xl font-medium mb-2">Simple Users:</h3>
                <p className="text-justify">
                  These are private individuals or property buyers who use the
                  Site and App for purposes different from Professional Users.
                  They typically use the platform to evaluate the shortlisted
                  properties and relevant information identified by their agent
                  for them to evaluate. These users will be provided by user
                  credentials to access the shortlisted properties.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-medium mb-2">
                  Professional Users:
                </h3>
                <p className="text-justify">
                  These are real estate agents, construction companies,
                  developers, builders and other professionals in the real
                  estate industry who use the platform to showcase and market
                  their projects and properties to Simple Users. Professional
                  Users gain access to specialized Services only after
                  contacting the Owner to activate their account, which is
                  subject to signing a service contract (hereinafter "Service
                  Contract").
                </p>
              </div>
            </section>

            {/* Permitted and Prohibited Uses */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Permitted and Prohibited Uses
              </h2>
              <p className="mb-4 text-justify">
                Commercial use of the Site and App outside the Service Contract,
                including access, transfer, or misuse of information contained
                within, is strictly prohibited and will be prosecuted according
                to the law.
              </p>
              <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                <p className="font-medium text-red-700">
                  Prohibited activities include:
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1 text-justify">
                  <li>
                    Transmitting or distributing any material that violates the
                    law
                  </li>
                  <li>Using the Site for illegal or unethical activities</li>
                  <li>Reproducing content without authorization</li>
                </ul>
              </div>
            </section>

            {/* Intellectual Property */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Intellectual Property
              </h2>
              <p className="text-justify">
                The Owner is the rightful holder of all intellectual and
                industrial property rights related to the Site and App,
                including, but not limited to, texts, images, graphics,
                software, and trademarks. Users may not reproduce, modify,
                distribute, or otherwise exploit these elements without prior
                authorization from the Owner or other rights holders.
              </p>
            </section>

            {/* Contact Information */}
            <section className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-4">
                Contact Information
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium mb-2">
                    For communications with authorities:
                  </h3>
                  <a
                    href="mailto:product@hospinetinfra.com"
                    className="text-blue-600 hover:underline"
                  >
                    product@hospinetinfra.com
                  </a>
                </div>
                <div className="border rounded-lg p-4">
                  <h3 className="font-medium mb-2">
                    For communications with Users:
                  </h3>
                  <a
                    href="mailto:devices@hospinetinfra.com"
                    className="text-blue-600 hover:underline"
                  >
                    devices@hospinetinfra.com
                  </a>
                </div>
              </div>
              <p className="mt-4 text-sm text-gray-600 text-justify">
                All communications must be in English.
              </p>
            </section>

            {/* Acceptance Button */}
            {/* <div className="flex justify-center mt-8">
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg shadow-md transition duration-300">
                I Accept the Terms & Conditions
              </button>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};
